export default __webpack_public_path__ + "static/media/chevron-down.ba6a70da.svg";